import { useState } from "react"
import { Dialog, DialogContent, DialogContentText } from "@mui/material"
import { toast } from "react-toastify"
import image from "../../assets/images/credit-card-mockup.png"
import AppButton from "../common/AppButton"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import useExitIntent from "../../hooks/useExitIntent"

const Loyalty = () => {
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const isLoggedIn = useSelector((state) => state?.userAuth?.isLoggedIn)

  useExitIntent({
    onExitIntent: () => {
      setIsOpen(true)
    },
    threshold: 10,
    delay: 100,
    enabled: !isLoggedIn,
    sessionKey: "loyalty_exit_intent_shown",
  })

  const handleSubmit = () => {
    setIsLoading(true)
    setIsOpen(false)

    toast.success("Success! Begin your onboarding now.")

    setTimeout(() => {
      navigate("/auth/signup")
      setIsLoading(false)
    }, 3000)
  }

  const handleClose = () => {
    setIsOpen(false)
    sessionStorage.setItem("loyalty_exit_intent_shown", "true")
  }

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        "& .MuiPaper-root": {
          width: "auto",
          maxWidth: "none",
        },
      }}
    >
      <div>
        <DialogContent
          sx={{
            py: { xs: "22px", md: "44px" },
            px: { xs: "15.5px", md: "31px" },
            minWidth: { md: "582px" },
            boxSizing: "border-box",
          }}
        >
          <DialogContentText id="alert-dialog-description">
            <div className="flex justify-center">
              <img src={image} alt="credit card mockup" className="max-w-[258px] h-[234.52px]" />
            </div>
            <div className="mt-[25px] flex flex-col items-center">
              <h2 className="font-bold text-center text-2xl text-[#5C068C]">
                Claim Your Free Gro Loyalty Card
              </h2>
              <p className="mt-[12px] text-center text-gray-600 w-[85%]">
                Begin your onboarding now
              </p>
            </div>
            <div className="mt-[25px]">
              <AppButton
                onClick={handleSubmit}
                className="rounded !w-full flex-none !h-[55px]"
                gradient
                type="submit"
              >
                {isLoading ? "Claiming ..." : "Claim Now"}
              </AppButton>
              <AppButton
                onClick={handleClose}
                className="rounded !w-full flex-none !text-gray-600 !h-[55px]"
              >
                No, Thanks.
              </AppButton>
            </div>
          </DialogContentText>
        </DialogContent>
      </div>
    </Dialog>
  )
}

export default Loyalty
